export default "__VITE_ASSET__DnsiIbba__"